/* eslint-disable max-len */
import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';

import { withRouter } from 'react-router-dom';
import gql from 'graphql-tag';
import moment from 'moment-timezone';

import apolloClient from '../../../../utils/apolloClient';
import Details from './Details';
import { Loading } from '../../../../components/elements';
import SquareLogo from './SquareLogo';
import { getAuthUrl } from '../PosIntegrations/helpers';
// import { useDisconnectSquareAccessFunc } from './helpers';

const squarePosConfigurationQuery = gql`
  query fetch_place($placeId: String!) {
    fetch_place(input: { place_id: $placeId }) {
      square {
        accessToken
        businessName
        code
        country
        createdAt
        currency
        languageCode
        id
        mainLocationId
        refreshToken
        status
      }
    }
  }
`;

const Container = styled.div`
  width: 70%;
`;

const SquarePos = ({ values }) => {
  const [fetchingUrl, setFetchingUrl] = useState(false);
  const [squarePopup, setSquarePopup] = useState();

  // const [
  //   squarePosConfiguration,
  //   {
  //     loading: squarePosConfigurationDataLoading,
  //     error: squarePosConfigurationDataError,
  //   },
  // ] = useMutation(squarePosConfigurationQuery, {
  //   client: apolloClient.clientPrivate,
  //   onCompleted: () => {},
  // });

  const {
    data,
    loading: squarePosConfigurationDataLoading,
    refetch: squarePosConfigurationRefetch,
  } = useQuery(squarePosConfigurationQuery, {
    variables: {
      placeId: values.place_id,
    },
    client: apolloClient.clientPrivate,
  });

  const squarePosConfigurationData = data?.fetch_place;

  const squarePosConfigurationDataRefetch = async () => {
    squarePosConfigurationRefetch();
  };

  // const [
  //   ,
  //   // validatingAccessToken,
  //   validationData,
  //   // getValidationData,
  //   ,
  // ] = useDisconnectSquareAccessFunc({
  //   placeId: values.place_id,
  //   onSuccess: squarePosConfigurationDataRefetch,
  // });

  const fetchAuthUrl = async () => {
    setFetchingUrl(true);

    const url = await getAuthUrl({ placeId: values.place_id });

    if (url) {
      const popup = window.open(url, 'popup', 'width=600,height=600');
      setSquarePopup(popup);
    }

    setFetchingUrl(false);
  };

  React.useEffect(() => {
    console.log('setting timezone =', values?.place?.timezone);
    moment.tz.setDefault(values?.place?.timezone);
  }, [values?.place?.timezone]);

  React.useEffect(() => {
    let popupChecker;

    if (squarePopup) {
      popupChecker = setInterval(() => {
        if (squarePopup.closed) {
          clearInterval(popupChecker);
          squarePosConfigurationDataRefetch();
        }
      }, 500);
    }

    return () => (popupChecker ? clearInterval(popupChecker) : null);
  }, [squarePopup]);

  if (squarePosConfigurationDataLoading) {
    return <Loading />;
  }

  return (
    <Container>
      <h1 className="is-size-2 has-text-weight-semibold">
        Square POS Integration
      </h1>
      <p className="is-size-3">
        We allow our restaurants to integrate with Square POS System
      </p>
      <br />
      <div className="columns">
        <div className="column">
          <SquareLogo />
        </div>
        {/* {squarePosConfigurationData?.read_square_access_token?.square?.id && (
          <div className="column is-2 has-text-right">
            <a
              className={`button is-primary ${validatingAccessToken &&
                'is-loading'}`}
              onClick={async () => getValidationData()}
            >
              <p className="has-text-weight-semibold">Disconnect</p>
            </a>
          </div>
        )} */}
        <div className="column is-2 has-text-right">
          <a
            className={`button ${
              squarePosConfigurationData?.square?.id
                ? 'is-success'
                : 'is-primary'
            } ${fetchingUrl && 'is-loading'}`}
            onClick={async () => fetchAuthUrl()}
            disabled={squarePosConfigurationData?.square?.id}
          >
            <p className="has-text-weight-semibold">
              {squarePosConfigurationData?.square?.id ? 'Connected' : 'Connect'}
            </p>
          </a>
        </div>
      </div>
      <Details
        key={squarePosConfigurationData?.square?.id}
        squarePosConfigurationData={squarePosConfigurationData}
      />
    </Container>
  );
};

export default withRouter(SquarePos);
